import CurrencyUtil from 'common/util/CurrencyUtil';
import ModalUtil from 'common/util/ModalUtil';

export class ProductSetsCart {
    $cart = $();
    #price = 0;
    #comparePrice = 0;
    #saving = 0
    #activeItems = [];
    #addedItems =[];
    #setAdded = false;
    #pluralRules = new Intl.PluralRules('ru-RU');
    #pluralRulesRuProducts = {
        'one': 'Товар',
        'few': 'Товара',
        'many': 'Товаров'
    }

    constructor($cart) {
        this.$cart = $cart;
        this.#price = parseFloat(this.$cart.attr('data-price'));
        this.#comparePrice = parseFloat(this.$cart.attr('data-compare-price'));
        this.#saving = parseFloat(this.$cart.attr('data-saving'));
        this.#addedItems.push(JSON.parse($cart.attr('data-added-items')));
        this.initEventListeners()
    }

    set price(price) {
        this.$cart.find('.product-sets-cart__price')
            .html(this.formatPrice(price));
        this.#price = price;
    }

    set comparePrice(comparePrice) {
        this.$cart.find('.product-sets-cart__compare-price')
            .html(this.formatPrice(comparePrice));
        this.#comparePrice = comparePrice;
    }

    set saving(saving) {
        this.$cart.find('.product-sets-cart__economy-price')
            .html(this.formatPrice(saving));
        this.#saving = saving;
    }

    get price() {
        return this.#price
    }

    get comparePrice() {
        return this.#comparePrice
    }

    get saving() {
        return this.#saving
    }

    checkAddedItems() {
        if (!this.#activeItems.length) {
            return;
        }

        this.#setAdded = false;
        const activeSkuIds = this.#activeItems.map(elm => elm.sku_id).sort();

        this.#addedItems.forEach((arr)=>{
            if (this.#setAdded) {
                return false;
            }

            this.#setAdded = arr.length === this.#activeItems.length && arr.sort().every((elm, ind) => elm === activeSkuIds[ind]);
        })

        const $addBtn = this.$cart.find('.product-sets-cart__add');

        if (this.#setAdded) {
            $addBtn.text('Перейти в корзину');
            $addBtn.attr('href', elkitorg_config.real_cart_url);
        } else {
            $addBtn.html($('<span>В&nbsp;корзину <br class="hide-on-mobile">комплектом</span>'));
            $addBtn.attr('href', '#')
        }
    }

    initActiveItems(items) {
        this.#activeItems = items;
    }
    activeItemsPush(item) {
        this.$cart.removeClass('product-sets-cart_disabled');
        this.#activeItems.push(item);
        this.addTooltipItem(item);
        this.checkAddedItems();
    }

    activeItemsRemove(skuId) {
        this.#activeItems = this.#activeItems.filter((elm) => elm.sku_id !== skuId);
        this.removeTooltipItem(skuId)
        this.checkAddedItems();

        if (!this.#activeItems.length) {
            this.$cart.addClass('product-sets-cart_disabled');
        }
    }

    addTooltipItem({sku_id, name, url}) {
        const $toolTipItem = $(`<a class="product-sets-cart__tooltip-item" target="_blank"></a>`)
        $toolTipItem.addClass("product-sets-cart__tooltip-item_" + sku_id);
        $toolTipItem.text(name);
        $toolTipItem.attr('title', name);
        $toolTipItem.attr('href', url);
        this.$cart.find('.product-sets-cart__tooltip').append($toolTipItem);
        this.setTitleProducts();
    }

    removeTooltipItem(skuId) {
        this.$cart.find(`.product-sets-cart__tooltip-item_${skuId}`).remove();
        this.setTitleProducts();
    }

    initEventListeners() {
        const $cartTitle = this.$cart.find('.product-sets-cart__title');

        $cartTitle.on('click', () => {
            $cartTitle.toggleClass('product-sets-cart__title_active');
            $cartTitle.find('.product-sets-cart__tooltip').slideToggle(300);
        });

        $cartTitle.on('blur', () => {
            $cartTitle.removeClass('product-sets-cart__title_active');
            $cartTitle.find('.product-sets-cart__tooltip').slideUp(300);
        })

        this.$cart.on('click', '.product-sets-cart__add', (e) => {
            e.preventDefault();

            if (this.#setAdded) {
                location.pathname = elkitorg_config.real_cart_url;
                return;
            }

            if (!this.#activeItems.length) {
                return;
            }

            const $btn = $(e.target);

            const data = {
                set_id: this.$cart.attr('data-set-id'),
                bundle_id: this.$cart.attr('data-bundle-id'),
                include_product: this.$cart.attr('data-include-product')
            };

            this.#activeItems.forEach((item, ind) => {
                const itemData = item.settings;
                data['items[' + ind + '][sku_id]'] = item.sku_id;
                data['items[' + ind + '][quantity]'] = itemData.quantity === '0' ? 1 : itemData.quantity;
                data['items[' + ind + '][_id]'] = itemData._id;
            })

            $.post($.productsets.urls['buy'], data)
                .done((response) => {
                    if (response.status == 'ok') {
                        $.ajax({
                            url: window.elkitorg_config.cart_save_url,
                            method: 'get',
                        }).then(function () {
                            $(document).trigger('shop_cart_update', arguments);
                        })
                        this.#addedItems.push(this.#activeItems.map(elm => elm.sku_id));
                        $btn.addClass('product-sets-cart__add_added');
                        $btn.text('Перейти в корзину')
                        this.#setAdded = true;

                        const $modalContent = $(this.$cart.find('#product-sets-modal__in-cart').prop('content').cloneNode(true).firstChild);
                        $modalContent.find('.product-sets-modal__continue').on('click', () => {
                            ModalUtil.close();
                        })

                        ModalUtil.openContent($modalContent);

                    } else if (response.status == 'fail' && response.errors) {
                        infoPanel.show(response.errors);

                        if (console) {
                            console.error(response.errors)
                        }
                    }
                }, 'json')
                .fail(function (jqXHR, textStatus, errorThrown) {
                    infoPanel.show($('<span>Что-то пошло не так</span>'));

                    if (console) {
                        console.error(jqXHR, textStatus, errorThrown);
                    }
                });
        });
    }

    plural(count) {
        return this.#pluralRules.select(count);
    }

    formatPrice(price) {
        return CurrencyUtil.format(price, elkitorg_config.currency_info[elkitorg_config.currency]);
    }

    setTitleProducts() {
        const text = `${this.#activeItems.length} ${this.#pluralRulesRuProducts[this.plural(this.#activeItems.length)]}`;
        this.$cart.find('.product-sets-cart__title-products').text(text)
    }
}